import { useInView } from 'react-intersection-observer';
import Skeleton from 'react-loading-skeleton';
import { useState } from 'react';

const PLACEHOLDER =
  'https://theme-assets.getbento.com/sensei/bac0892.sensei/assets/images/catering-item-placeholder-704x520.png';

const LazyImageOrder = ({ src, alt }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const [isLoaded, setIsLoaded] = useState(false);

  const imageSrc = src && src.trim() !== '' ? src : PLACEHOLDER;

  return (
    <div ref={ref}>
      {!isLoaded && <Skeleton height={200} />}
      {inView && (
        <img
          src={imageSrc}
          alt={alt || 'image'}
          loading="lazy"
          onLoad={() => setIsLoaded(true)}
          className="item-image"
  style={{

            opacity: isLoaded ? 1 : 0,
            transition: 'opacity 0.5s ease-in-out',
            position: 'relative',
          }}        />
      )}
    </div>
  );
};

export default LazyImageOrder;
